import React from 'react';
import routes from 'routes';
import { IRoute } from 'interfaces';
import AppContent from './AppContent';
import './AppLayout.scss';

const AppLayout: React.FC = () => {
  return <AppContent filteredRoutes={routes as IRoute[]} />;
};

export default AppLayout;
